"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TabsPanel = void 0;
var react_1 = __importDefault(require("react"));
var Container_1 = require("../Container/Container");
var TabsContext_1 = require("./TabsContext");
var TabsPanel = function (_a) {
    var index = _a.index, className = _a.className, children = _a.children, rest = __rest(_a, ["index", "className", "children"]);
    var _b = TabsContext_1.useTabsContext(), currentIndex = _b.currentIndex, uid = _b.uid;
    var isSelected = index === currentIndex;
    return (react_1["default"].createElement(Container_1.Container, __assign({ id: "tabpanel-" + uid + "-" + index, "aria-labelledby": "tab-" + uid + "-" + index, role: "tabpanel", hidden: !isSelected, className: [className, isSelected && 'is-selected'] }, rest), isSelected && children));
};
exports.TabsPanel = TabsPanel;
//# sourceMappingURL=TabsPanel.js.map